<template>
  <div id="removeclass">
    <modal
      :modal-id="modalId"
      :title="modalTitle"
      :preloader="preloader"
      @submit="submit"
      @close-modal="closeModal"
    >
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <form
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
          ref="form"
          :data-url="addurl"
        >
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <div class="form-group">
                <label>{{ $t("users") }}</label>
                <app-input
                  type="search-select"
                  :placeholder="$t('select_user')"
                  :list="this.users"
                  v-model="inputs.user_id"
                  :required="true"
                />
              </div>
            </div>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../Mixins/ModalMixin";
import * as actions from "../../../../../../Config/ApiUrl";
import { axiosPost, axiosGet } from "../../../../../../Helpers/AxiosHelper.js";
import AppLibrary from "../../../../../../Helpers/AppLibrary";

export default {
  name: "AddModal",
  extends: AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    taskId: String,
    id: Number,
  },
  data() {
    return {
      users: [],
      addurl: actions.CERTIFICATE_FORM_AUDIT_REQUEST,
      preloader: false,
      inputs: {
        // due_date: new Date(),
      },
      modalId: "certificate-form-audit-request",
      modalTitle: this.$t("audit_request"),
    };
  },
  //   created() {
  //     if (this.selectedUrl) {
  //       this.modalTitle = this.$t("edit");
  //       // this.postUrl = actions.MYDOCUMENT_UPDATE;
  //       // this.preloader = true;
  //     }
  //   },
  methods: {
    submit() {
      //  if (this.inputs.due_date)
      //       this.inputs.due_date = this.getDateFormatForBackend(this.inputs.due_date);
      // this.inputs.task_id = this.taskId;
      this.inputs.task_id = this.id; 
      this.save(this.inputs);
    },
    afterSuccess(res) {
      this.preloader = false;
      this.hideModal();
      this.$toastr.s(res.data.message);
      this.$emit("afterSubmitDone");
    },
    afterError() {
      this.preloader = false;
      this.closeModal();
    },
    hideModal() {
      $("#" + this.modalId).modal("hide");
    },
    closeModal() {
      this.hideModal();
      this.$emit("close-modal");
    },
    getUsers() {
      axiosGet(actions.GET_COMPANY_USERS)
        .then((res) => {
          this.users = res.data;
        })
        .catch((error) => {
          
        });
    },
  },

  mounted() {
    this.getUsers();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
